export const resolveExampleCover = (
  cover: string | undefined,
  publicPath: string
) => {
  const source = (cover || '/img/vchart/bar-stack.png').replace(
    'tosv.byted.org',
    'lf9-dp-fe-cms-tos.byteorg.com'
  );

  // Repository preview paths are served from the configured static asset root.
  if (source.startsWith('/') && !source.startsWith('//')) {
    return `${publicPath.replace(/\/$/, '')}${source}`;
  }

  return source;
};
